import { render } from "./DickTwo.vue?vue&type=template&id=9bfc89de"
import script from "./DickTwo.vue?vue&type=script&lang=js"
export * from "./DickTwo.vue?vue&type=script&lang=js"

import "./DickTwo.vue?vue&type=style&index=0&id=9bfc89de&lang=css"
script.render = render

export default script